var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1499,
    height: 195,
    viewBox: "0 0 1499 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0A303A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M75.2 2c-148.6 8-32.8 33.6 20.2 33.6s156.3 47.8 317 28.3c160.7-19.4 211.8-37.4 331.3-37.4 119.4 0 394 78 483 74.3 48.6-2 200.6 15 338.9 145.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1);
export default __webpack_public_path__ + "static/media/path-1.5b8dc4c9afdc5fdba1280e600143518b.svg";
export { ForwardRef as ReactComponent };